module.exports = __webpack_public_path__ + "img/bosses-aire.a1ef5ea9.jpg";